module.exports = __webpack_public_path__ + "static/media/bootcamp.806d1195.svg";